import { render, staticRenderFns } from "./TheFormRestaurants1.vue?vue&type=template&id=5fca2d74&scoped=true&"
import script from "./TheFormRestaurants1.vue?vue&type=script&lang=ts&"
export * from "./TheFormRestaurants1.vue?vue&type=script&lang=ts&"
import style0 from "./TheFormRestaurants1.vue?vue&type=style&index=0&id=5fca2d74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca2d74",
  null
  
)

export default component.exports